// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","nav":"Footer_nav__EWR3i"};